import { Link } from "react-router-dom";
import PillarBadge from "./PillarBadge";
import FavoriteButton from "./FavoriteButton";
import MatchBadge from "./MatchBadge";
import { money } from "@/lib/currency";

export default function ExperienceCard({ exp }) {
  return (
    <Link data-testid={`experience-card-${exp.id}`} to={`/experience/${exp.id}`} className="group block animate-fade-up">
      <div className="relative overflow-hidden rounded-2xl mb-4 aspect-[4/5] bg-subtle">
        <img
          src={exp.images?.[0]}
          alt={exp.title}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 right-3">
          <FavoriteButton expId={exp.id} initialCount={exp.favorite_count || 0} />
        </div>
        <div className="absolute top-3 left-3 flex flex-col gap-1.5 items-start">
          {exp.verified && (
            <div className="rounded-full bg-moss text-canvas px-2.5 py-1 text-[10px] font-semibold tracking-wider uppercase" data-testid={`verified-badge-${exp.id}`}>✓ Verified</div>
          )}
          {typeof exp.match_score === "number" && <MatchBadge score={exp.match_score} />}
        </div>
      </div>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {exp.pillars?.slice(0, 3).map((p) => <PillarBadge key={p} pillar={p} />)}
      </div>
      <div className="overline">{exp.location} · {exp.duration_days} days</div>
      <h3 className="font-serif text-2xl leading-snug mt-1 group-hover:text-moss transition-colors">{exp.title}</h3>
      <div className="flex items-baseline justify-between mt-2 text-sm">
        <span className="text-muted2">
          {exp.avg_rating ? (
            <span className="inline-flex items-center gap-1"><span className="text-terracotta">★</span>{exp.avg_rating} <span className="text-xs">({exp.review_count})</span></span>
          ) : (
            <>Hosted by {exp.host_name}</>
          )}
        </span>
        <span className="font-medium text-ink">{money(exp.price_usd)}<span className="text-muted2 text-xs"> / guest</span></span>
      </div>
    </Link>
  );
}
